import { Coins } from '@terra-money/terra.js'
import BigNumber from 'bignumber.js'
import { AssetInfo } from 'interfaces/contracts/edgeEtoken'
import { Asset } from 'interfaces/contracts/edgePool'

export const isNativeTokenInfo = (toBeDetermined: AssetInfo): boolean => {
  if ('native_token' in toBeDetermined) {
    return true
  } else {
    return false
  }
}

export const isNativeTokenTerraAddress = (addr: string): boolean => {
  return !addr.startsWith('terra')
}

export const extractAddrOrDenomFromInfo = (input: AssetInfo): string => {
  if ('native_token' in input) {
    return input.native_token.denom
  } else {
    return input.token.contract_addr
  }
}

export const toAssetInfo = (token: string): AssetInfo => {
  const type = token.includes('terra') ? 'token' : 'native_token'
  if (type === 'token') {
    return {
      token: {
        contract_addr: token,
      },
    }
  } else {
    return {
      native_token: {
        denom: token,
      },
    }
  }
}

export const toAsset = (token: string, amount: BigNumber): Asset => {
  const assetInfo = toAssetInfo(token)

  return {
    amount: amount.toString().split('.')[0],
    info: assetInfo,
  }
}

export const getCoins = (token: Asset): Coins | undefined => {
  if ('native_token' in token.info) {
    return new Coins({
      [token.info.native_token.denom]: Number(token.amount),
    })
  }
  return undefined
}
